<template>
  <span>
    <div
      class="kbx-progress-label"
      style="left: 50%;"
      :style="getDivStyle()">
      <span class="kbx-progress-svg" v-html="getSVG()"></span>
      <span
        klickbox-edit-item="progress-bar-active"
        klickbox-edit-item-dad="progress"
        :klickbox-edit-label="$t('edit.canvas.active_item')"
        :style="getSpanStyle()"
        class="kbx-label-content">50%</span>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    getStyle() {
      return this.stepStyle('progress-bar-active');
    },
    getDivStyle() {
      const styles = this.getStyle();

      const kind = this.boxConfig.progressbar.kind;

      if (kind === 'svg') {
        return {};
      }

      return { backgroundColor: styles.borderColor };
    },
    getSpanStyle() {
      const styles = this.getStyle();

      const kind = this.boxConfig.progressbar.kind;

      if (kind === 'svg') {
        return { color: styles.color };
      }

      return {
        backgroundColor: styles.backgroundColor,
        color: styles.color,
      };
    },
    getSVG() {
      const kind = this.boxConfig.progressbar.kind;

      if (kind !== 'svg') {
        return '';
      }

      const span = document.createElement('span');
      const progressBarSVG = this.boxConfig.progressbar.svg.bar;
      const styles = this.getStyle();

      if (!progressBarSVG) {
        return span;
      }

      span.innerHTML = progressBarSVG;
      const svg = span.firstChild;

      if (!styles) {
        return svg.outerHTML;
      }

      svg.style.fill = styles.backgroundColor;
      svg.style.stroke = styles.borderColor;

      return svg.outerHTML;
    },
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Active.vue?d95b7c88
 **/